export let OS = /*#__PURE__*/function (OS) {
  OS["Ios"] = "ios";
  OS["Android"] = "android";
  OS["Windows"] = "windows";
  OS["Linux"] = "linux";
  OS["Mac"] = "mac";
  OS["Unknown"] = "unknown";
  return OS;
}({});

/**
 * Detects user operation system
 */
function detectOS() {
  const {
    userAgent
  } = window.navigator;
  if (/iPad|iPhone|iPod/.test(userAgent.toString())) return OS.Ios;
  if (userAgent.indexOf('Android') !== -1) return OS.Android;
  if (userAgent.indexOf('Windows') !== -1) return OS.Windows;
  if (userAgent.indexOf('Linux') !== -1) return OS.Linux;
  if (userAgent.indexOf('Mac OS') !== -1) return OS.Mac;
  return OS.Unknown;
}

/**
 * By default checks if device is iOS 15 or 16.
 *
 * If version parameter is provided it will check if user agent includes any major iOS version "iPhone OS {version}_y_z"
 * @returns true or false
 */
export function isLatestIphoneOS(version) {
  var _navigator$userAgent, _navigator;
  const ua = (_navigator$userAgent = (_navigator = navigator) == null ? void 0 : _navigator.userAgent) != null ? _navigator$userAgent : '';
  const isVersion = _version => ua.includes(`iPhone OS ${_version}`);
  if (version) {
    return isVersion(version);
  }
  return isVersion(15) || isVersion(16);
}
export default detectOS;